export function video01() {
  var blocks = document.querySelectorAll(".c-video01");
  if (!blocks.length) return;

  var deferUntilPlay =
    (typeof window.matchMedia === "function" &&
      window.matchMedia("(max-width: 768px)").matches) ||
    "ontouchstart" in document.documentElement;

  for (var i = 0; i < blocks.length; i++) {
    (function (block) {
      var video = block.querySelector("video");
      var btn = block.querySelector(".c-video01__play");
      if (!video || !btn) return;

      var lazySrc = null;
      if (deferUntilPlay) {
        lazySrc = video.getAttribute("src");
        if (lazySrc) {
          video.removeAttribute("src");
          video.load();
        }
      }

      // デスクトップ Safari: 未再生時に1フレーム目が出ない場合の対策（lazy でないときのみ）
      var didPrimeFrame = false;
      function tryPrimeFirstFrame() {
        if (didPrimeFrame || lazySrc) return;
        if (video.readyState < 2) return;
        didPrimeFrame = true;
        try {
          if (video.currentTime === 0) {
            video.currentTime = 0.001;
          }
        } catch (e) {
          didPrimeFrame = false;
        }
      }
      video.addEventListener("loadeddata", tryPrimeFirstFrame);
      video.addEventListener("canplay", tryPrimeFirstFrame);

      function startPlayback() {
        block.classList.add("is-playing");
        video.muted = false;
        if (video.currentTime < 0.02) {
          video.currentTime = 0;
        }
        var p = video.play();
        if (p && typeof p.catch === "function") {
          p.catch(function () {
            block.classList.remove("is-playing");
          });
        }
      }

      btn.addEventListener("click", function () {
        if (lazySrc && !video.getAttribute("src")) {
          video.setAttribute("src", lazySrc);
          video.load();
          var onReady = function () {
            video.removeEventListener("loadeddata", onReady);
            video.removeEventListener("canplay", onReady);
            startPlayback();
          };
          video.addEventListener("loadeddata", onReady);
          video.addEventListener("canplay", onReady);
          return;
        }
        startPlayback();
      });

      video.addEventListener("click", function () {
        if (!block.classList.contains("is-playing")) return;
        if (video.paused) {
          video.muted = false;
          var p2 = video.play();
          if (p2 && typeof p2.catch === "function") p2.catch(function () {});
        } else {
          video.pause();
        }
      });
    })(blocks[i]);
  }
}
